<form [formGroup]="form">
  <app-sla-selector [form]="form"></app-sla-selector>

  <app-lista-titulares [titulares]="titulares" [tipoOrdem]='"ACAO"' (titularesChange)="onTitularesChange($event)"></app-lista-titulares>

  <h3 class="subtitulo">Dados para inclusão</h3>

  <div class="form-row margin-bottom">
    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Valor da Dívida</mat-label>
        <input
          maxlength="16"
          value=""
          required
          matInput
          [currencyMask]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
          placeholder="Valor da Dívida"
          formControlName="vlrAcao"
          [attr.data-cy]="'input-valor-divida'"
        />
        <mat-error *ngIf="vlrAcao.hasError('required')">
          Valor da dívida é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="vlrAcao.hasError('valueZeroError')">
          O Valor não pode ser <strong>0,00</strong>
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Autor</mat-label>
        <input matInput required placeholder="Autor" formControlName="autor" maxlength="55" noSpecialChars [attr.data-cy]="'input-autor'"/>
        <mat-hint align="end">{{ autor.value?.length }} / 55</mat-hint>
        <mat-error *ngIf="autor.hasError('required')">
          Nome do autor / Exequente é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="autor.hasError('valueOnlyNumberError')">
          Nome do autor não pode conter apenas números
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline" class="inputs">
        <mat-label>Réu</mat-label>
        <input matInput required placeholder="Réu" formControlName="reu" maxlength="55" noSpecialChars [attr.data-cy]="'input-reu'"/>
        <mat-hint align="end">{{ reu.value?.length }} / 55</mat-hint>
        <mat-error *ngIf="reu.hasError('required')">
          Nome do réu / executado é <strong>obrigat&oacute;rio</strong>
        </mat-error>
        <mat-error *ngIf="reu.hasError('valueOnlyNumberError')">
          Nome do réu não pode conter apenas números
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <br />
  <div class="row">
    <div class="col-sm-7"></div>
    <div class="col-sm-5">
      <app-acao-buttons
        [tipoOrdem]="'ACAO'"
        (onConfirmar)="incluirOrdem()"
      ></app-acao-buttons>
    </div>
  </div>
</form>
